<template>
    <div class="panel">
        <div class="panel__header">
            <h2>
                <i class="panel__header__icon icons icon-magnifier"></i>
                <span>{{$t('dashboard.surveys.title')}}</span>
            </h2>
            <div @click.prevent="addNew" class="panel_header__action">
                <i class="panel_header__action__icon icons icon-plus"></i>
                <a class="button--link">{{$t('dashboard.surveys.add_new')}}</a>
            </div>
        </div>
        <div class="panel__body">
            <surveys-table />
        </div>
        <survey-modal />
        <survey-answers-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import SurveysTable from '@/components/tables/dashboard/SurveysTable';
    import SurveyModal from '@/components/modals/dashboard/SurveyModal';
    import SurveyAnswersModal from '@/components/modals/dashboard/SurveyAnswersModal';

    import Survey from '@/models/Survey';

    @Component({
        components: {
            SurveysTable,
            SurveyModal,
            SurveyAnswersModal,
        }
    })
    export default class SurveysPanel extends Vue {
        name = 'surveys-panel';

        addNew() {
            const url = `/trajectories/${this.$store.state.trajectory.trajectory.id}/surveys`;
            const survey = new (Survey.makeModel(url));
            this.$modal.show('survey-modal', { survey });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/SurveysPanel.vue